/** @jsxImportSource @emotion/react */
import { css } from '@mui/material'
import { TOP_NAVBAR_HEIGHT } from '@app/app-constants'
import { theme } from '@app/styles/theme'

export const riskLayoutContentWrapperStyle = css`
  height: calc(100vh - ${TOP_NAVBAR_HEIGHT}px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const shellContainer = css`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: Inter;
  min-height: 100vh;
  background-color: #fff;
  position: relative;
`

export const contentWrapper = css`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: 100%;
  flex: 1 1 auto;
  gap: ${theme.spacing(4)};
`

export const mainContentArea = css`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

export const pageContentContainer = css`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
`
